import React from 'react';

const ProgressBarComponent = (props: any) => {
    return (
        <div className='progress-bar-component' style={{margin:'0', alignItems: 'center', display: 'flex', justifyContent: 'center'}}> 
            <section className={`progress ${props.className}`} style={{width: '100%', height: '18px', position: 'relative'}}>
                <strong style={{color:'black', textAlign: 'center', width: '100%', position: 'absolute'}}>
                    {(props.percentual??'') == '' ? '0' : parseInt(props.percentual)}% 
                </strong>
                <div
                    className={"progress-bar" + (props.percentual>=100?'':' progress-bar-striped progress-bar-animated')}
                    role="progressbar" 
                    style={{width: `${(props.percentual)}%`, backgroundColor: props.color??'rgb(0, 104, 195)', verticalAlign: 'bottom'}} 
                    aria-valuemin={0} 
                    aria-valuemax={props.maxValue??100}>
                </div>
            </section>
        </div>);
}

export default ProgressBarComponent